import { CAST_LOOKS, CAST_PREFIX, castKeyOf } from '../../lib/validate/cast';
import type { Issue } from '../../lib/validate';
import { Field, SelectInput } from './fields';

const SEX = { m: 'man', f: 'woman' } as const;

/** The dropdown's options: every authored cast look (art/pop/catalog/cast.json), "Name (key), man|woman". No free-text codes. */
const CAST_LOOK_OPTIONS = CAST_LOOKS.map((c) => ({
  value: CAST_PREFIX + c.key,
  label: `${c.name} (${c.key}), ${c.child ? 'child' : SEX[c.sex]}${c.preset ? ', preset' : ''}`,
}));

/**
 * POP T31: a named character's authored look, `appearance: "cast:<key>"`. Empty = rolled from the look seed. The picked cast's
 * notes (who they are and why this look) show under the dropdown.
 */
export function CastLookField({
  value,
  issues,
  onChange,
}: {
  value: string | null | undefined;
  issues?: Issue[];
  onChange: (v: string | undefined) => void;
}) {
  const key = castKeyOf(value);
  const entry = key ? CAST_LOOKS.find((c) => c.key === key) : undefined;
  return (
    <Field
      label="Cast look"
      hint={
        entry
          ? entry.notes
          : 'None = rolled from the look seed. Add looks in art/pop/catalog/cast.json.'
      }
      issues={issues}
    >
      {(id, invalid) => (
        <SelectInput
          id={id}
          invalid={invalid}
          none="(rolled from the look seed)"
          value={value ?? ''}
          options={CAST_LOOK_OPTIONS}
          onChange={(v) => onChange(v ?? undefined)}
        />
      )}
    </Field>
  );
}
